// Mock data for CCN Sanluri redesign
export const brand = {
  name: "CCN Sanluri",
  fullName: "Centro Commerciale Naturale di Sanluri",
  tagline: "Il cuore commerciale, artigiano e culturale di Sanluri",
  city: "Sanluri",
  region: "Sardegna",
  email: "info@sanluriccn.it",
  phone: "+39 070 000 0000",
  address: "Via Carlo Felice, 249 · 09025 Sanluri (SU)",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Attività", to: "/attivita" },
  { label: "Eventi", to: "/eventi" },
  { label: "Contatti", to: "/contatti" },
];

// NOTE: The `categories` array previously defined here was stale (missing
// 'servizi', wrong slug 'associazioni' instead of 'enti-associazioni') and is
// no longer imported anywhere in the live UI. All consumers now load categories
// dynamically from /api/categories via publicApi.listCategories(). If you need
// the category list at runtime, use the API — do NOT re-introduce a hardcoded
// array here (single source of truth = Supabase).

export const listings = [
  {
    id: "cisalpina-tours",
    name: "Cisalpina Tours",
    subtitle: "Servizi Turistici di Stefano Urpi",
    description:
      "Cisalpina Tours – Servizi Turistici di Stefano Urpi offre a Sanluri un supporto completo e professionale per viaggi, vacanze e business travel.",
    category: "turismo",
    tags: ["Agenzie di viaggio", "Turismo"],
    phone: "347 678 2590",
    address: "Via Carlo Felice 249",
    hours: "Lun–Ven 09:00–13:00 / 16:00–19:30",
    status: "OPEN",
    rating: 4.9,
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1200&q=80",
  },
  {
    id: "alma-beauty-store",
    name: "Alma Beauty Store",
    subtitle: "Forniture professionali",
    description:
      "Punto di riferimento a Sanluri per forniture professionali destinate a parrucchieri, estetiste e centri benessere.",
    category: "commercio",
    tags: ["Commercio", "Artigianato", "Estetista"],
    phone: "070 753 9968",
    address: "Viale Matteotti",
    hours: "Mar–Sab 09:30–13:00 / 16:30–20:00",
    status: "OPEN",
    rating: 4.8,
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&q=80",
  },
  {
    id: "krissclima",
    name: "KrissClima",
    subtitle: "Consulenza & Elettrodomestici",
    description:
      "Agenzia di consulenza commerciale specializzata in climatizzazione, energia ed elettrodomestici per case e uffici.",
    category: "commercio",
    tags: ["Commercio", "Elettrodomestici"],
    phone: "070 938 7212",
    address: "Via Sulcis",
    hours: "Lun–Ven 09:00–19:00",
    status: "CLOSED",
    rating: 4.7,
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80",
  },
  {
    id: "visionottica-sanluri",
    name: "VisionOttica Sanluri",
    subtitle: "Il tuo centro ottico di fiducia",
    description:
      "Centro ottico specializzato nella vendita di occhiali da vista, da sole e lenti a contatto. Consulenza personalizzata.",
    category: "commercio",
    tags: ["Commercio", "Ottico"],
    phone: "392 347 1434",
    address: "Via Carlo Felice",
    hours: "Lun–Sab 09:30–13:00 / 16:30–20:00",
    status: "OPEN",
    rating: 4.9,
    image: "https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=1200&q=80",
  },
  {
    id: "tripudium-danze",
    name: "Tripudium Danze",
    subtitle: "Associazione Sportiva Dilettantistica",
    description:
      "Associazione di Sanluri che promuove attività di danza, ballo di coppia e discipline artistiche per tutte le età.",
    category: "associazioni",
    tags: ["Associazioni", "Sport"],
    phone: "340 472 0800",
    address: "Via Roma",
    hours: "Lun–Ven 17:00–22:00",
    status: "OPEN",
    rating: 5.0,
    image: "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=1200&q=80",
  },
  {
    id: "studio-caneglias",
    name: "Studio Tecnico Marcello Caneglias",
    subtitle: "Perizie assicurative",
    description:
      "Studio attivo nel settore delle perizie assicurative a Sanluri, con approccio tecnico rigoroso e trasparente.",
    category: "commercio",
    tags: ["Consulenza"],
    phone: "379 150 1982",
    address: "Via San Pietro",
    hours: "Lun–Ven 09:00–13:00 / 15:00–18:00",
    status: "CLOSED",
    rating: 4.8,
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80",
  },
  {
    id: "panificio-medau",
    name: "Panificio Medau",
    subtitle: "Pane, pizza e dolci sardi",
    description:
      "Storico panificio artigianale del centro di Sanluri. Pane carasau, coccoi, pizza e dolci tipici sardi ogni giorno.",
    category: "artigianato",
    tags: ["Artigianato", "Alimentari", "Pizza"],
    phone: "070 930 1122",
    address: "Via Carlo Felice 88",
    hours: "Lun–Sab 06:30–13:30 / 17:00–20:00",
    status: "OPEN",
    rating: 4.9,
    image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1200&q=80",
  },
  {
    id: "trattoria-su-nuraxi",
    name: "Trattoria Su Nuraxi",
    subtitle: "Cucina sarda tradizionale",
    description:
      "Piatti sardi cucinati come una volta, ingredienti locali e cantina con etichette del territorio del Medio Campidano.",
    category: "commercio",
    tags: ["Ristorante", "Cucina sarda"],
    phone: "070 930 4567",
    address: "Piazza San Rocco",
    hours: "Mar–Dom 12:30–14:30 / 19:30–23:00",
    status: "OPEN",
    rating: 4.7,
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=80",
  },
];

export const events = [
  {
    id: "sanluri-incontra-carloforte",
    title: "Sanluri incontra Carloforte",
    date: "2025-08-14",
    time: "18:30",
    location: "Piazza Castello, Sanluri",
    category: "Cultura",
    short: "Un ponte tra due comunità della Sardegna: musica, cucina e tradizioni.",
    description:
      "Serata dedicata all’incontro tra Sanluri e Carloforte: degustazione di piatti tabarchini e sardi, musica dal vivo e mostra fotografica delle due comunità.",
    image: "https://images.pexels.com/photos/27471164/pexels-photo-27471164.jpeg",
  },
  {
    id: "elisabetta-viviani-trio",
    title: "Elisabetta Viviani & il Trio Viviani in concerto",
    date: "2025-09-05",
    time: "21:00",
    location: "Teatro Comunale, Sanluri",
    category: "Musica",
    short: "Un viaggio musicale intimo con la storica cantante italiana.",
    description:
      "La celebre voce di Elisabetta Viviani insieme al suo Trio propone un concerto che intreccia canzone d’autore italiana e pagine indimenticabili.",
    image: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1200&q=80",
  },
  {
    id: "voci-contro-la-violenza",
    title: "Voci contro la Violenza",
    date: "2025-11-25",
    time: "20:30",
    location: "Auditorium San Rocco, Sanluri",
    category: "Sociale",
    short: "Serata di sensibilizzazione contro la violenza di genere.",
    description:
      "Letture, testimonianze e musica in occasione della Giornata Internazionale per l’eliminazione della violenza contro le donne.",
    image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1200&q=80",
  },
  {
    id: "cena-sotto-le-stelle",
    title: "Cena sotto le stelle nel Centro Storico",
    date: "2025-07-19",
    time: "20:00",
    location: "Corso Repubblica, Sanluri",
    category: "Gastronomia",
    short: "Le vie del centro diventano una lunga tavolata sotto le stelle.",
    description:
      "Ristoratori e produttori locali propongono menu tipici lungo il corso principale. Musica dal vivo, artigiani e degustazioni di vini del Campidano.",
    image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=1200&q=80",
  },
  {
    id: "fiera-del-medio-campidano",
    title: "Fiera del Medio Campidano",
    date: "2025-10-11",
    time: "10:00",
    location: "Piazza degli Eroi, Sanluri",
    category: "Mercato",
    short: "Prodotti tipici, artigianato e cultura del territorio.",
    description:
      "Due giorni dedicati ai sapori e ai mestieri del Medio Campidano: espositori, laboratori, showcooking e attività per famiglie.",
    image: "https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=1200&q=80",
  },
  {
    id: "notte-bianca-sanluri",
    title: "Notte Bianca di Sanluri",
    date: "2025-08-30",
    time: "19:00",
    location: "Centro storico, Sanluri",
    category: "Festival",
    short: "Negozi aperti fino a tardi, musica, spettacoli e street food.",
    description:
      "La notte in cui Sanluri non dorme: shopping, concerti in piazza, mostre e stand gastronomici animano tutto il centro storico.",
    image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1200&q=80",
  },
];

export const stats = [
  { value: 80, suffix: "+", label: "Attività associate" },
  { value: 24, suffix: "", label: "Eventi ogni anno" },
  { value: 15, suffix: "K", label: "Visitatori all’anno" },
  { value: 12, suffix: "", label: "Anni di storia" },
];

export const testimonials = [
  {
    name: "Giulia Puddu",
    role: "Cliente affezionata",
    quote:
      "Il centro di Sanluri è di nuovo vivo. Trovo tutto quello che cerco a pochi passi da casa, e ogni volta scopro una nuova attività.",
  },
  {
    name: "Marco Serra",
    role: "Titolare, Panificio Medau",
    quote:
      "Grazie al Centro Commerciale Naturale abbiamo creato una rete vera tra colleghi. Insieme siamo più forti e visibili.",
  },
  {
    name: "Chiara Loi",
    role: "Turista da Cagliari",
    quote:
      "Ho scoperto Sanluri grazie a un evento del CCN: cibo eccezionale, gente calorosa e negozi bellissimi. Tornerò sicuramente.",
  },
];

export const faqs = [
  {
    q: "Che cos’è un Centro Commerciale Naturale?",
    a: "È una rete di attività commerciali, artigianali e di servizio che condividono un’area urbana e collaborano per valorizzarla, come se fosse un unico grande centro commerciale a cielo aperto.",
  },
  {
    q: "Come posso associare la mia attività?",
    a: "Puoi scriverci dalla pagina Contatti o chiamare la nostra segreteria: ti accompagneremo passo passo nella procedura di adesione.",
  },
  {
    q: "Gli eventi sono aperti a tutti?",
    a: "Sì, tutti i nostri eventi sono aperti al pubblico. Alcuni potrebbero richiedere prenotazione: trovi tutte le informazioni nella pagina dedicata.",
  },
  {
    q: "Posso segnalare un’attività mancante?",
    a: "Assolutamente sì. Usa il modulo di contatto per segnalarci qualsiasi attività sanlurese che merita di essere raccontata.",
  },
];

export const partners = [
  "Comune di Sanluri",
  "Regione Sardegna",
  "Camera di Commercio",
  "Confcommercio",
  "Confesercenti",
  "Pro Loco Sanluri",
  "Medio Campidano",
];
